import { useMemo } from 'react'
import { TRANSACTION_DTYPE, LEDGER_ENTRY_TYPE } from 'Data/payments.js'
import { useDataValue } from 'Simple/Data.js'

let DTYPE_TO_LEDGER_ENTRY_TYPE = /** @type {const} */ ({
  [TRANSACTION_DTYPE.LateFeeCharge]: LEDGER_ENTRY_TYPE.CHARGE,
  [TRANSACTION_DTYPE.RetailFeeCharge]: LEDGER_ENTRY_TYPE.CHARGE,
  [TRANSACTION_DTYPE.TxFeeCharge]: LEDGER_ENTRY_TYPE.CHARGE,
  [TRANSACTION_DTYPE.InstallmentCharge]: LEDGER_ENTRY_TYPE.CHARGE,
  [TRANSACTION_DTYPE.MiscFeeCharge]: LEDGER_ENTRY_TYPE.CHARGE,
  [TRANSACTION_DTYPE.ChargeTransfer]: LEDGER_ENTRY_TYPE.CHARGE_TRANSFER,
  [TRANSACTION_DTYPE.TransferCharge]: LEDGER_ENTRY_TYPE.TRANSFER_CHARGE,
  [TRANSACTION_DTYPE.PaymentPlan]: LEDGER_ENTRY_TYPE.PAYMENT_PLAN,
  [TRANSACTION_DTYPE.PaymentPlanRollback]:
    LEDGER_ENTRY_TYPE.PAYMENT_PLAN_ROLLBACK,
  [TRANSACTION_DTYPE.Payment]: LEDGER_ENTRY_TYPE.APPLIED_PAYMENT,
  [TRANSACTION_DTYPE.UnappliedPayment]: LEDGER_ENTRY_TYPE.UNAPPLIED_PAYMENT,
  [TRANSACTION_DTYPE.DiscountReverseAdjustment]: LEDGER_ENTRY_TYPE.ADJUSTMENT,
})

let LEDGER_ENTRY_TYPE_ORDER = [
  LEDGER_ENTRY_TYPE.CHARGE,
  LEDGER_ENTRY_TYPE.ADJUSTMENT,
  LEDGER_ENTRY_TYPE.TRANSFER_CHARGE,
  LEDGER_ENTRY_TYPE.CHARGE_TRANSFER,
  LEDGER_ENTRY_TYPE.PAYMENT_PLAN,
  LEDGER_ENTRY_TYPE.PAYMENT_PLAN_ROLLBACK,
  LEDGER_ENTRY_TYPE.APPLIED_PAYMENT,
  LEDGER_ENTRY_TYPE.UNAPPLIED_PAYMENT,
  LEDGER_ENTRY_TYPE.PAYMENT,
  LEDGER_ENTRY_TYPE.NOTE,
]

export default function useDataTransform(props, data) {
  let order = useDataValue({
    viewPath: props.viewPath,
    context: 'tab',
    path: 'selected.ledger.order',
  })

  return useMemo(() => {
    if (!data) return data

    let result = []
    result.push(
      ...data.transactions.map(item => ({
        ...item,
        type: DTYPE_TO_LEDGER_ENTRY_TYPE[item.dtype],
        sort_date: item.effective_date ?? item.sys_created,
        payment_account:
          item.receivable?.payment_account ??
          item.applied_payment?.payment?.payment_account,
      }))
    )
    result.push(
      ...data.notes.map(item => ({
        ...item,
        type: LEDGER_ENTRY_TYPE.NOTE,
        sort_date: item.sys_created,
      }))
    )
    result.push(
      ...data.payments.map(item => ({
        ...item,
        type: LEDGER_ENTRY_TYPE.PAYMENT,
        sort_date: item.sys_created,
      }))
    )

    // Sort by sort_date, then by entry type order
    // Transactions use effective_date as sort_date; notes and payments use sys_created
    result.sort((a, b) => {
      let dateComparison =
        order === 'asc'
          ? new Date(a.sort_date) - new Date(b.sort_date)
          : new Date(b.sort_date) - new Date(a.sort_date)
      if (dateComparison !== 0) return dateComparison

      let getOrder = type => {
        let i = LEDGER_ENTRY_TYPE_ORDER.indexOf(type)
        return i === -1 ? 99 : i
      }
      return getOrder(a.type) - getOrder(b.type)
    })

    return result
  }, [data, order])
}
